import * as z from "zod";

export const handleRedoSuppliesCheckoutCompleted = {
  name: "handleRedoSuppliesCheckoutCompleted" as const,
  input: z.object({ checkoutSessionId: z.string() }),
  output: z.object({ orderId: z.string(), orderName: z.string() }),
};
